<template>
    <div class="simple-home-main">
        <van-grid :column-num="3" :border="false">
            <van-grid-item icon="photo-o" text="大牌咖啡" to="/goods?categoryId=1"/>
            <van-grid-item icon="photo-o" text="甜品饮品" to="/goods?categoryId=1"/>
            <van-grid-item icon="photo-o" text="品牌餐饮" to="/goods?categoryId=1"/>
            <van-grid-item icon="photo-o" text="旅游特权" to="/goods?categoryId=1"/>
            <van-grid-item icon="photo-o" text="品牌特惠" to="/goods?categoryId=1"/>
        </van-grid>
    </div>    
</template>

<script>
import {Grid, GridItem} from "vant";
export default {
    name: 'SimpleHome',
    components: {
        [Grid.name]: Grid,
        [GridItem.name]: GridItem
    },
    data() {
        return {};
    },
    mounted() {
    }
}
</script>

<style lang="less">
.simple-home-main {
    padding-top: 160px;
    height: 100vh;
    background-color: white;
    box-sizing: border-box;
}
</style>